import { NgModule } from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {TeamInfoComponent} from '@team-modules/team-info/team-info.component';
import {TeamInfoFunctionariesComponent} from '@team-modules/team-info/pages/functionaries/team-info-functionaries.component';
import {TeamInfoStadionComponent} from '@team-modules/team-info/pages/stadion/team-info-stadion.component';
import {TeamInfoContactComponent} from '@team-modules/team-info/pages/contact/team-info-contact.component';
import {TeamRoutes} from '@app/routes/team.routes';

export const routes: Routes = [
  {
    path: '',
    component: TeamInfoComponent,
    children: [
      { path: '', redirectTo: TeamRoutes.info.functionaries, pathMatch: 'full' },
      { path: TeamRoutes.info.functionaries, component: TeamInfoFunctionariesComponent },
      { path: TeamRoutes.info.stadium, component: TeamInfoStadionComponent },
      { path: TeamRoutes.info.contact, component: TeamInfoContactComponent },
    ],
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TeamInfoRouting { }
